import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";

const ProductSection = ({
  weekIndex,
  deliveryIndex,
  control,
  register,
  getValues,
  errors,
  setValue,
  planPriceValues,
  watchedWeeks,
  settotal_price,
  total_price,
  setOnchangeValue,
  watch,
  onchageValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `weeks.${weekIndex}.deliveries.${deliveryIndex}.products`,
  });

  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [variant, setVariant] = useState([]);

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-vendor-p-categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };

  const Select4Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      name: name,
      unit: data?.Unit,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };

  const getAllProducts = async (id) => {
    const response = await getData(`/common/masters/product/${id}`);
    if (response?.success) {
      setProducts(await Select4Data(response?.data, "product_id"));
    }
  };

  const Select3Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      name: name,
      price: data?.price,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };

  const getAllvariant = async (id) => {
    const response = await getData(`/common/masters/product-varient/${id}`);
    if (response?.success) {
      setVariant(await Select3Data(response?.data, "variant_id"));
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
    <>
      {fields.map((product, productIndex) => (
        <Row key={product.id} className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Category</Form.Label>
              <Controller
                control={control}
                name={`weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.category_id`}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={categories}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption.value);
                      getAllProducts(selectedOption.value);
                      setValue(
                        `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.category_id`,
                        selectedOption
                      );
                      setValue(
                        `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.product_id`,
                        ""
                      );
                      setValue(
                        `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.variant_id`,
                        ""
                      );
                    }}
                  />
                )}
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group>
              <Form.Label>Product</Form.Label>
              <Controller
                control={control}
                name={`weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.product_id`}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={products}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption.value);
                      getAllvariant(selectedOption.value);
                      setValue(
                        `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.product_id`,
                        selectedOption
                      );
                      setValue(
                        `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.variant_id`,
                        ""
                      );
                    }}
                  />
                )}
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group>
              <Form.Label>
                Variant (
                {getValues(
                  `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.product_id.unit.name`
                ) || "Select"}
                )
              </Form.Label>
              <Controller
                control={control}
                name={`weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.variant_id`}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={variant}
                    onChange={(val) => {
                      field.onChange(val); 
                      // setOnchangeValue((prev) => !prev); 
                    }}
                  />
                )}
              />

              {/* <Controller
                control={control}
                name={`weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.variant_id`}
                render={({ field }) => <Select {...field} options={variant} />}
                onChange={(e) => {
                  setOnchangeValue((prev) => !prev); // toggle for recalculation
                }}
              /> */}
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group>
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="text"
                {...register(
                  `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.quantity`,
                  {
                    required: "Quantity required",
                    validate: (value) =>
                      value.length <= 200 ||
                      "Data must be 200 characters or less",
                  }
                )}
                className={classNames({
                  "is-invalid":
                    errors?.weeks?.[weekIndex]?.deliveries?.[deliveryIndex]
                      ?.products?.[productIndex]?.quantity,
                })}
                onKeyDown={(e) => {
                  // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                  if (
                    !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "."
                  ) {
                    e.preventDefault(); // Prevent the event if it's not allowed
                  }

                  // Prevent entering more than one decimal point
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
                // onChange={(e) => {
                //   setOnchangeValue((prev) => !prev); // toggle for recalculation
                // }}
              />
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group>
              <Form.Label>
                Serving Size(
                {getValues(
                  `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.product_id.unit.name`
                ) || "Select"}
                )
              </Form.Label>
              <Form.Control
                type="text"
                {...register(
                  `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.serving_size`,
                  {
                    required: "Serving size required",
                    validate: (value) =>
                      value.length <= 200 ||
                      "Data must be 200 characters or less",
                  }
                )}
                onKeyDown={(e) => {
                  // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                  if (
                    !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "."
                  ) {
                    e.preventDefault(); // Prevent the event if it's not allowed
                  }

                  // Prevent entering more than one decimal point
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group>
              <Form.Label>
                Caloriesy(
                {getValues(
                  `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.product_id.unit.name`
                ) || "Select"}
                )
              </Form.Label>
              <Form.Control
                type="text"
                {...register(
                  `weeks.${weekIndex}.deliveries.${deliveryIndex}.products.${productIndex}.calories`,
                  {
                    required: "Calories required",
                    validate: (value) =>
                      value.length <= 200 ||
                      "Data must be 200 characters or less",
                  }
                )}
                onKeyDown={(e) => {
                  // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                  if (
                    !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "."
                  ) {
                    e.preventDefault(); // Prevent the event if it's not allowed
                  }

                  // Prevent entering more than one decimal point
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Group>
          </Col>

          <Col md={12}>
            <button
              type="button"
              className="btn btn-danger mt-2"
              onClick={() => remove(productIndex)}
            >
              Remove Product
            </button>
          </Col>
        </Row>
      ))}

      <button
        type="button"
        className="btn btn-secondary me-2"
        onClick={() => append({})}
      >
        + Add Product
      </button>
    </>
  );
};

export default ProductSection;
